/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_item">;
    readonly " $refType": "SharedItemTile_item";
};
export type SharedItemTile_item$data = SharedItemTile_item;
export type SharedItemTile_item$key = {
    readonly " $data"?: SharedItemTile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedItemTile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showSeller",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ]
    }
  ]
};
(node as any).hash = 'e6ac9316bcebe48eec558272f6cb10f1';
export default node;
